module.exports = __webpack_public_path__ + "img/tjzy.370d509b.png";